import dayjs from 'dayjs';
import { z } from 'zod/v4';

export const DayjsSchema = z
  .custom<dayjs.Dayjs>((val) => val instanceof dayjs, `Fecha inválida`)
  .refine((data) => data.isValid());
